import { render } from "./SingleQuestion.vue?vue&type=template&id=f391a758"
import script from "./SingleQuestion.vue?vue&type=script&lang=js"
export * from "./SingleQuestion.vue?vue&type=script&lang=js"

import "./SingleQuestion.vue?vue&type=style&index=0&id=f391a758&lang=css"

import exportComponent from "/Users/bob/Documents/GitHub/cdsa/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__